const STORAGE_KEY = 'page-nav-snapshots';
const MAX_PAGES = 20;

const read = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

/**
 * The few fields a page's sidebar is built from: its type picks the screens, and its prices,
 * status and test mode pick the rest. Nothing else of the page is kept.
 */
export const toNavSnapshot = page => ({
  _id: page._id,
  type: page.type,
  status: page.status,
  testmode: page.testmode,
  productType: page.productType,
  product: page.product
    ? {
        type: page.product.type,
        prices: (page.product.prices ?? []).map(({ enabled, billingType }) => ({
          enabled,
          billingType,
        })),
      }
    : undefined,
});

export function saveNavSnapshot(page) {
  if (!page?._id || !page.type) return;
  try {
    const others = read().filter(snapshot => snapshot._id !== page._id);
    const next = [toNavSnapshot(page), ...others].slice(0, MAX_PAGES);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Storage full or blocked: the sidebar waits for the page, as it would on a first visit.
  }
}

export function readNavSnapshot(pageId) {
  if (!pageId) return null;
  return read().find(snapshot => snapshot._id === pageId) ?? null;
}
